"use client";

const NETWORK = process.env.NEXT_PUBLIC_STELLAR_NETWORK === "mainnet" ? "MAINNET" : "TESTNET";

export function StatusBar() {
  return (
    <footer
      className="fixed bottom-0 inset-x-0 z-30 h-7 flex items-center justify-between px-7 max-[900px]:px-5 max-[600px]:px-3.5"
      style={{
        background: "rgba(6,6,6,0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderTop: "1px solid var(--border-subtle)",
      }}
      aria-label="Status bar"
    >
      <div className="flex items-center gap-1.5">
        <span
          className="w-1.5 h-1.5 rounded-full animate-pulse"
          style={{ background: "var(--green)" }}
          aria-hidden="true"
        />
        <span className="text-[10px] tracking-[0.18em] uppercase" style={{ color: "var(--text-secondary)" }}>
          STELLAR · {NETWORK}
        </span>
      </div>
      <span className="text-[10px] tracking-[0.12em] uppercase hidden sm:inline" style={{ color: "var(--text-tertiary)" }}>
HOOPS FINANCE · v0.6.0
      </span>
    </footer>
  );
}
